// Lib
import gql from 'graphql-tag';

// Types
import { AUTH_GROUP } from '../types';

export const authGroupCreate = gql`
  mutation AuthGroupCreate($input: AuthGroupCreateInput, $skipAuths: Boolean = false) {
    authGroupCreate(input: $input) {
      ${AUTH_GROUP}
    }
  } 
`;

export const authGroupUpdate = gql`
  mutation AuthGroupUpdate($input: AuthGroupUpdateInput, $skipAuths: Boolean = false) {
    authGroupUpdate(input: $input) {
      ${AUTH_GROUP}
    }
  }
`;

export const authGroupsUpdateBulk = gql`
  mutation AuthGroupsUpdateBulk($input: AuthGroupsUpdateBulkInput, $skipAuths: Boolean = false) {
    authGroupsUpdateBulk(input: $input) {
      ${AUTH_GROUP}
    }
  }
`;

export const authGroupDelete = gql`
  mutation AuthGroupDelete($input: AuthGroupDeleteInput) {
    authGroupDelete(input: $input)
  }
`;

export const authGroupImportAuthCsv = gql`
  mutation AuthGroupImportAuthCsv($input: AuthGroupImportFromCsvInput, $skipAuths: Boolean = false) {
    authGroupImportAuthCsv(input: $input) {
      ${AUTH_GROUP}
    }
  }
`;

export const authGroupManageMultipleGroupsForAuth = gql`
  mutation AuthGroupManageMultipleGroupsForAuth(
    $input: AuthGroupManageMultipleGroupsForAuthInput
  ) {
    authGroupManageMultipleGroupsForAuth(input: $input)
  }
`;
